import React from "react";
import { Link2, Share2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";

async function copy(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  }
}

// Shares the current (filter-synced) catalogue URL via clipboard or WhatsApp.
export default function ShareCollection() {
  const url = () => window.location.href.split("#")[0];
  const onCopy = async () => {
    if (await copy(url())) toast.success("Link copied to clipboard!");
    else toast.error("Couldn't copy — please copy the address bar link.");
  };
  const onWhatsApp = () => {
    const text = `Check out our latest collection: ${url()}`;
    window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, "_blank", "noopener");
  };
  return (
    <div className="flex items-center gap-2" data-testid="share-collection">
      <Button variant="outline" className="rounded-full h-11 bg-white" onClick={onCopy} data-testid="share-copy-link-btn">
        <Link2 className="h-4 w-4 sm:mr-1.5" /><span className="hidden sm:inline">Share Collection</span>
      </Button>
      <Button className="rounded-full h-11 bg-[#25D366] hover:bg-[#1ebe5b] text-white" onClick={onWhatsApp} data-testid="share-whatsapp-btn">
        <Share2 className="h-4 w-4 sm:mr-1.5" /><span className="hidden sm:inline">Share on WhatsApp</span>
      </Button>
    </div>
  );
}
